var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.75 12.904a7.928 7.928 0 0 0 1.875-5.093C15.625 3.504 12.117 0 7.811 0 3.504 0 0 3.504 0 7.811s3.504 7.814 7.81 7.814a7.925 7.925 0 0 0 5.094-1.875l6.094 6.075c.113.113.26.175.413.175.153 0 .3-.063.412-.175a.57.57 0 0 0 0-.826zm-5.94 1.542a6.643 6.643 0 0 1-6.634-6.635 6.643 6.643 0 0 1 6.635-6.635 6.643 6.643 0 0 1 6.634 6.635 6.643 6.643 0 0 1-6.634 6.635"
  })));
};
export default SvgSearch;